import { Component, Input, Output, EventEmitter, OnInit, Inject } from '@angular/core';
import { MarketsService } from '@src/services/markets/markets.service';
import { Market } from '@src/model/market';
import { DataTableHelpers } from '@src/shared/helpers/datatable-helper';
import { TranslateService } from '@ngx-translate/core';
import { WindowEventsDispatcher } from '@src/core/WindowEventsDispatcher';
import { PagedTableModel } from '@src/shared/tables/paged-table-model';
import { Subject } from 'rxjs';
import { NgxDatatableBase } from '@src/shared/tables/ngx-datatable-base';
import { ConfigService } from '@src/services/layout/config.service';

@Component({
    selector: 'app-wizard-select-market',
    templateUrl: './wizard-select-market.html'
})
export class WizardSelectMarketComponent extends NgxDatatableBase implements OnInit {
    model = new PagedTableModel();
    selected: Market[] = [];
    firstLoad = false;
    queryTermChanged: Subject<string> = new Subject<string>();
    @Output() onMarketSelect = new EventEmitter<Market>();
    @Input() numberOfRows = 8;
    layoutDirection: string;
    pagerLeftArrowIcon: string;
    pagerRightArrowIcon: string;
    pagerPreviousIcon: string;
    pagerNextIcon: string;

    constructor(
        private marketsService: MarketsService,
        private translateService: TranslateService,
        private configService: ConfigService) {
        super(translateService);
        this.model.sortOrder = 'name asc';
        this.model.pageSize = this.numberOfRows;
        this.setTableIconsByOrientation();
    }
    ngOnInit() {
        this.queryTermChanged
            .debounceTime(1000) // wait 1000ms after the last event before emitting last event
            .distinctUntilChanged() // only emit if value is different from previous value
            .subscribe(v => {
                this.model.queryTerm = v;
                this.getMarkets(1);
            });
        this.getMarkets(1);
    }
    private setPage(pageInfo) {
        this.getMarkets(pageInfo.page);
    }
    private onSort(event) {
        if (this.model.isLoading) {
            return;
        }
        const sort = event.sorts[0];
        this.model.sortOrder = `${sort.prop} ${sort.dir}`;
        this.getMarkets(1);
    }
    private onSelect(market: any) {
        this.onMarketSelect.emit(market.selected[0]);
    }
    private onSearch(event: any) {
        const textValue = event.target.value.trim();
        this.queryTermChanged.next(textValue);
    }
    private getMarkets(page: number) {
        if (this.model.isLoading) {
            return;
        }
        if (page < 1) {
            page = 1;
        }
        this.model.isLoading = true;
        this
            .marketsService
            .queryActiveMarkets(this.model.queryTerm, this.model.sortOrder, this.model.pageSize, page)
            .subscribe(data => {
                this.model.rows = data.body.value;
                this.model.totalElements = data.headers.get('pageCount');
                this.model.pageNumber = page;
                this.model.offset = page - 1;
                if (this.firstLoad) {
                    // When the page changes and the lst page has little items, the width is incorrectly displayed (scrollbar problems)
                    // Force table size recalculation and re-render.
                    // this.table.recalculate();
                    WindowEventsDispatcher.fireDelayedResizeEvent(0);
                }
                this.firstLoad = true;
                this.model.isLoading = false;
            });
    }
    reset() {
        this.selected = [];
    }

    setTableIconsByOrientation() {
        this.layoutDirection = this.configService.templateConf.layout.dir;
        this.pagerLeftArrowIcon = this.layoutDirection === 'rtl' ? 'datatable-icon-right' : 'datatable-icon-left';
        this.pagerRightArrowIcon = this.layoutDirection === 'rtl' ? 'datatable-icon-left' : 'datatable-icon-right';
        this.pagerPreviousIcon = this.layoutDirection === 'rtl' ? 'datatable-icon-skip' : 'datatable-icon-prev';
        this.pagerNextIcon = this.layoutDirection === 'rtl' ? 'datatable-icon-prev' : 'datatable-icon-skip';
    }
}

